export const BINDER_FILTERS = "BinderFilters";
export const BINDER_SORT_ORDER = "BinderSortOrder";
export const CURRENT_USER = "currentUser";
export const INTRO_DISMISSED = "introDismissed";
export const IS_AUTHENTICATED = "isAuthenticated";
export const PFA_MATCH_DEFAULT = "pfaMatchDefault";
export const SEARCH_SIDEBAR_OPEN = "searchSidebarOpen";
export const SEARCH_START_ANALYTICS_OPEN = "customSearchAnalyticsOpen";
export const SEARCH_START_CUSTOM_OPEN = "customSearchCustomSearchOpen";
export const SEARCH_START_PROFILES_OPEN = "customSearchProfilesOpens";
export const SEARCH_START_REPORTS_OPEN = "customSearchComparisonReportsOpen";
export const SEARCH_START_SHOW_ALL_TARGETS = "customSearchShowShowAllTargets";
export const DATA_WARNING_SHOWN = "dataWarningShown";
